// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
const hiddenDisplays = new WeakMap();

/**
 * Shows or hides `target`, restoring its previous inline display value when a hidden target is shown. A target a
 * stylesheet still hides is shown with `display: revert`, its element's default display.
 */
export function setTargetVisibility(target, visible) {
  if (visible) {
    if (target.style.display === "none") {
      target.style.display = hiddenDisplays.get(target) || "";
    }

    hiddenDisplays.delete(target);

    if (getComputedStyle(target).display === "none") {
      target.style.display = "revert";
    }
  } else {
    if (target.style.display !== "none") {
      hiddenDisplays.set(target, target.style.display);
    }

    target.style.display = "none";
  }
}
